/**
 * Dynamite brand theme overrides.
 * Deep-merged on top of the shared base theme via extendTheme.
 * TODO: Add component-level style overrides specific to Dynamite.
 */
import colors from './colors'
import fonts from './fonts'
import {textStyles} from './foundations/typography'

// Project Component style overrides
import TopBar from './components/project/top-bar'
import ListMenu from './components/project/list-menu'
import Cart from './components/project/cart'
import Text from './components/base/text'
import Button from './components/base/button'

export default {
    colors,
    fonts,
    textStyles,
    brandId: 'dynamite',
    components: {
        TopBar,
        ListMenu,
        Cart,
        Text,
        Button
    }
}
